const GDPRConsentLocation = {
    NO_ONE: 'NoOne',
    EVERY_ONE: 'Everyone',
    PARTIAL: 'Partial',
    EXPLICIT: 'MicrosoftRecipients'
};

export default GDPRConsentLocation;
